import React from "react"

import Header from "../../../design-system/header"
import Modal from "../../../design-system/modal"
import Paragraph from "../../../design-system/paragraph"
import ScrollContinuationGradient from "../../../design-system/scroll-continuation-gradient"
import OptimizedImage, {
  DatoCmsImageUrl,
} from "../../../shared-components/optimized-image"
import VendorCardImage from "../catalog-panel/catalog-table/catalog-table-row/vendor-card-image"
import { CatalogItem } from "../catalog-panel/catalog-table/types"
import { Country } from "../countries"
import { getCurrencyName } from "../currencies"
import * as styles from "./index.module.scss"

type Props = {
  catalogItem: CatalogItem
  modalType?: "country" | "currency"
  onClose: () => void
}

const getFlag = (countryCode: string): DatoCmsImageUrl => {
  const code = countryCode.toLowerCase()

  switch (code) {
    case "ac":
      return "https://www.datocms-assets.com/85985/1690210971-flag_of_ascension_island.jpeg"
    case "tp":
      return "https://www.datocms-assets.com/85985/1690211021-flag_of_east_timor.svg"
    case "an":
      return "https://www.datocms-assets.com/85985/1690211061-flag_of_the_netherlands_antilles.svg"
    default:
      return `https://flagcdn.com/${code}.svg` as DatoCmsImageUrl
  }
}

const CatalogItemLocationModal = ({
  catalogItem,
  modalType,
  onClose,
}: Props) => {
  const { countries, currencyCodes } = catalogItem
  const isCountry = modalType === "country"

  return (
    <Modal open={!!modalType} onClose={onClose} className={styles.modal}>
      <div className={styles.container}>
        <Header as="h3" variant="3" className={styles.heading}>
          <div className={styles.imageContainer}>
            <VendorCardImage {...catalogItem} />
          </div>
          {catalogItem.name}
        </Header>
        <Paragraph variant="3">
          {isCountry
            ? "This redemption method is accepted in the following locations:"
            : "This redemption method is available in the listed currencies."}
        </Paragraph>
        <div className={styles.listWrapper}>
          <ScrollContinuationGradient size="0.5rem" variant="top" />
          <ScrollContinuationGradient size="1.5rem" variant="bottom" />
          <ul className={styles.list}>
            {isCountry
              ? countries
                  .sort((a: Country, b: Country) =>
                    a.label.localeCompare(b.label),
                  )
                  .map(country => (
                    <li key={country.code} className={styles.listItem}>
                      <OptimizedImage
                        className={styles.listImage}
                        src={getFlag(country.code)}
                        alt={`${country.label} flag`}
                        preset="graphic"
                      />
                      <Paragraph variant="3">{country.label}</Paragraph>
                    </li>
                  ))
              : currencyCodes.sort().map(currencyCode => (
                  <li key={currencyCode} className={styles.listItem}>
                    <Paragraph variant="3">
                      {currencyCode} - {getCurrencyName(currencyCode)}
                    </Paragraph>
                  </li>
                ))}
          </ul>
        </div>
      </div>
    </Modal>
  )
}

export default CatalogItemLocationModal
